import { render, staticRenderFns } from "./mail_receive.vue?vue&type=template&id=f63c0a50&scoped=true&"
import script from "./mail_receive.vue?vue&type=script&lang=js&"
export * from "./mail_receive.vue?vue&type=script&lang=js&"
import style0 from "./mail_receive.vue?vue&type=style&index=0&id=f63c0a50&scoped=true&lang=less&"
import style1 from "./mail_receive.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63c0a50",
  null
  
)

export default component.exports